import Cognito from 'Interface/Cognito';
import api from 'Service';

const url = '/cognito';

const apiExtendida = api.enhanceEndpoints({}).injectEndpoints({
  endpoints: (construtor) => ({
    getCognitoToken: construtor.query<Cognito, void>({
      query: () => url,
    }),
  }),
  overrideExisting: false,
});

export const { useGetCognitoTokenQuery } = apiExtendida;
